<script setup lang="ts">
  const { data, indent = 1 } = defineProps<{
    data: unknown;
    indent?: number;
  }>();

  const isObject = (value: unknown) => value !== null && (typeof value === "object" || Array.isArray(value));
</script>

<template>
  <div class="logging-data">
    <template v-if="isObject(data)">
      <div
        v-for="(value, key) in data"
        :key="key"
        class="logging-data__row"
        :class="{ 'logging-data__row--nested': isObject(value) }"
      >
        <div class="logging-data__key">{{ key }}:</div>
        <template v-if="isObject(value)">
          <div class="logging-data__nested" style="padding-left: 10px">
            <div class="logging-data__nested-content">
              <LogData :data="value" :indent="indent + 1" />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="logging-data__value">{{ value }}</div>
        </template>
      </div>
    </template>
    <template v-else>
      <div>{{ data }}</div>
    </template>
  </div>
</template>

<style scoped>
  .logging-data__row {
    display: flex;
    margin-bottom: 4px;
    flex-wrap: wrap;
  }

  .logging-data__row--nested {
    flex-direction: column;
  }

  .logging-data__key {
    font-weight: 500;
    color: var(--sf-base-text-secondary);
    margin-right: 4px;
    white-space: nowrap;
  }

  .logging-data__nested {
    width: 100%;
  }

  .logging-data__nested-content {
    border-left: 2px solid #e5e5e5;
    padding-left: 8px;
    margin: 4px 0;
  }

  .logging-data__value {
    padding-left: 4px;
    word-break: break-word;
    flex: 1;
    color: var(--sf-base-text-primary);
  }
</style>
